import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InfoPageComponent } from './info-page/info-page.component';
import { AboutBudgetComponent } from './about-budget.component';

//import { CanDeactivateGuard } from '../core';
import { EventCalendarComponent } from '../events/event-calendar/event-calendar.component';


const routes: Routes = [
  {
    path: '',
    component: AboutBudgetComponent,
    children: [
      {
        path: ':id',
        component: InfoPageComponent,
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AboutBudgetRoutingModule { }

export const routedComponents = [
  InfoPageComponent,
  AboutBudgetComponent,
  EventCalendarComponent
];



// WEBPACK FOOTER //
// ./src/app/about-budget/about-budget-routing.module.ts